import apiClient from '@app/config/axios.config'
import { useQuery } from '@tanstack/react-query'
import { LiveFeedResponse } from '../Live.types'

const LAYERS_QUERY_KEY = 'live-layers'
const LAYERS_ENDPOINT = '/layer/live_feeds'

export function useFetchLiveLayers() {
  return useQuery<LiveFeedResponse>({
    queryKey: [LAYERS_QUERY_KEY],
    queryFn: async () => {
      return await apiClient.get(LAYERS_ENDPOINT)
    },
  })
}
